import { PeakDefinitionsResponse } from '@classpass/protobuf-definitions/lib/web/domain/partners/peak_definitions';
import { useQuery } from '@tanstack/react-query';

import URLS from 'constants/urls';
import { reportError } from 'helpers/error-logging';
import { httpClient } from 'helpers/http';

export const peakDefinitionsKeys = {
  byVenue: venueId => ['peakDefinitions', venueId],
};

// Without this a 5xx trips the global overlay and replaces the whole SmartTools page.
const REQUEST_CONFIG = { ignoreInternalError: true };

async function fetchPeakDefinitions(venueId) {
  try {
    const response = await httpClient.get(URLS.peakDefinitions.byVenue(venueId), REQUEST_CONFIG);
    return PeakDefinitionsResponse.fromJSON(response?.data || {});
  } catch (error) {
    reportError(error);
    throw error;
  }
}

export function usePeakDefinitionsQuery(venueId, options = {}) {
  return useQuery({
    queryKey: peakDefinitionsKeys.byVenue(venueId),
    queryFn: () => fetchPeakDefinitions(venueId),
    enabled: !!venueId,
    // The default three retries would hold the skeleton through four sequential 504s.
    retry: 1,
    ...options,
  });
}
